import { StyleSheet, Text, View } from "@react-pdf/renderer";
import { useMemo } from "react";
import PDFCheckChildrenDefects from "./PDFCheckChildrenDefects";
import PDFCheckTable from "./PDFCheckTable";
import { PDFPage } from "./PDFLayout";
import { tableStyles } from "./PDFTable";
import { createPDFCheckFruitTablePagePlan, MAX_FRUIT_ROWS_PER_PAGE } from "./utils/pdfCheckFruitTablePagination";

export const styles = StyleSheet.create({
    metaContainer: {
        borderWidth: 1,
        borderColor: "#e3e3e6",
        borderRadius: 5,
        padding: 10,
        marginBottom: 10,
        width: "70%",
    },
    fullWidth: {
        width: "100%",
    },
    container: {
        borderWidth: 1,
        borderColor: "#e3e3e6",
        borderRadius: 5,
        padding: 10,
        marginBottom: 10,
        width: "40%",
    },
    horizontalMargins: {
        marginLeft: 5,
        marginRight: 5,
    },
    divider: {
        borderBottomWidth: 1,
        borderBottomColor: "#e3e3e6",
        paddingBottom: 4,
        marginBottom: 4,
    },
    cell: {
        width: "100%",
    },
    metaItems: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        color: "#939496",
        fontSize: 9,
        marginBottom: 1,
    },
    row: {
        flexDirection: "row",
        justifyContent: "space-between",
    },
    metaTextValueIntakeReport: {
        color: "#4f4f4f",
    },
    metaTextValueArtReport: {
        color: "#4f4f4f",
        fontWeight: "bold",
        marginBottom: 2,
        marginLeft: 8,
        textAlign: "right",
        justifyContent: "flex-end",
    },
});

// TODO: Remove any
export function PDFCheckFruitTables({
    header,
    rows,
    footer,
    title,
    fields,
    check,
    layer,
    defect_groups,
    tenantDefectDefinitions,
    logo_path,
    header_title,
    anchorId,
}: any) {
    const headers = useMemo(() => header.map((i, index) => (
        <View key={index} style={[tableStyles.tableCell, tableStyles.tableCellHeight, tableStyles.tableHeader]}>
            <Text style={tableStyles.tableHeaderText}>{i || "\u00A0"}</Text>
        </View>
    )), [header]);

    const pagePlan = useMemo(
        () => createPDFCheckFruitTablePagePlan<any, any>(fields, rows),
        [fields, rows]
    );

    if (headers.length === 0) {
        return null;
    }

    const getTableColumns = (pageRows, includeFooter) => header.map((_, columnIndex) => [
        headers[columnIndex],
        ...pageRows.map((row, rowIndex) => (
            <View style={[tableStyles.tableCellHeight, tableStyles.tableCell]} key={`row-${rowIndex}`}>
                {row[columnIndex]?.display_vector() || "\u00A0"}
            </View>
        )),
        ...(includeFooter ? [
            <View style={[tableStyles.tableCell, tableStyles.tableCellHeight, tableStyles.tableHeader]} key="footer">
                <Text style={tableStyles.tableHeaderText}>{footer[columnIndex] || "\u00A0"}</Text>
            </View>
        ] : []),
    ]);

    const renderTable = (pageRows, includeFooter) => (
        <PDFCheckTable
            maxRows={MAX_FRUIT_ROWS_PER_PAGE + 2}
            columns={getTableColumns(pageRows, includeFooter)}
        />
    );

    return (
        <>
            {pagePlan.summaryFieldPages.map((pageFields, pageIndex) => {
                const showDefects = pageIndex === 0;
                const includeTable = pagePlan.combineSummaryAndTable && pageIndex === 0;

                return (
                    <PDFPage footer key={`summary-${pageIndex}`} logo_path={logo_path} header_title={header_title} anchorId={pageIndex === 0 ? anchorId : undefined}>
                        <View>
                            <Text style={tableStyles.pageTitle}>{title}</Text>
                        </View>

                        <View style={styles.row}>
                            <View style={showDefects ? styles.metaContainer : [styles.metaContainer, styles.fullWidth]}>
                                <View style={styles.cell}>
                                    {pageFields.map((item, index) => (
                                        <View key={index} style={styles.metaItems}>
                                            <View style={{ maxWidth: "30%" }}>
                                                <Text>{item.label}:</Text>
                                            </View>

                                            <View style={{ ...styles.metaTextValueIntakeReport, maxWidth: "70%" }}>
                                                {item.display_vector(9, 152, 150)}
                                            </View>
                                        </View>
                                    ))}
                                </View>
                            </View>

                            {showDefects && defect_groups
                                .filter((i) => i.pdf_show_on_pallet_level !== false)
                                .map((group, index) => (
                                    <PDFCheckChildrenDefects
                                        key={index}
                                        tenantDefectDefinitions={tenantDefectDefinitions}
                                        defect_group={group}
                                        check={check}
                                        layer={layer}
                                    />
                                ))}
                        </View>

                        {includeTable && renderTable(rows, true)}
                    </PDFPage>
                );
            })}

            {pagePlan.tableRowPages.map((pageRows, pageIndex) => (
                <PDFPage footer key={`table-${pageIndex}`}>
                    {renderTable(pageRows, pageIndex === pagePlan.tableRowPages.length - 1)}
                </PDFPage>
            ))}
        </>
    );
}
